<template>
    <div>
        <page-title>购买插件</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="站点" prop="host_id">
                    <el-select v-model="form.host_id" filterable placeholder="请选择">
                        <el-option
                                v-for="item in hostList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                :disabled="item.status != 1">
                            <span style="float: left">{{item.name}}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{item.domain}}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="应用" prop="app_id">
                    <el-select v-model="form.app_id" filterable placeholder="请选择" @change="search()">
                        <el-option
                                v-for="item in appList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="插件" prop="plugin_id" v-if="form.app_id">
                    <el-select v-model="form.plugin_id" filterable placeholder="请选择">
                        <el-option
                                v-for="item in pluginList"
                                :key="item.id"
                                :label="item.display_name"
                                :value="item.id">
                            <span style="float: left">{{item.display_name}}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">￥{{item.price}}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">立即下单</el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            loading: false,
            btnLoading: false,
            hostList: null,
            pluginList: null,
            appList: null,
            rules: {
                app_id: [
                    {required: true, message: '请选择应用。'}
                ],
                host_id: [
                    {required: true, message: '请选择站点。'}
                ],
                plugin_id: [
                    {required: true, message: '请选择插件。'}
                ]
            },
            form: {
                app_id: '',
                host_id: '',
                plugin_id: ''
            }
        }
    },
    created() {
        this.loadData()
    },
    mounted() {
        if (this.$route.query.id) {
            this.form.plugin_id = +this.$route.query.id
        }
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'user/app/index'
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.appList = e.data.data.list
                }
            })
            axios({
                url: 'user/host/index',
                params: {
                    app_id: this.form.app_id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.hostList = e.data.data.list
                }
            })
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: 'user/plugin-order/create',
                        params: {
                            id: this.form.id
                        },
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('订单提交成功。')
                            this.$router.push({
                                path: '/dashboard/plugin-order/index'
                            })
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        },
        search() {
            this.form.plugin_id = ''
            axios({
                url: 'user/plugin/index',
                params: {
                    app_id: this.form.app_id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.pluginList = e.data.data.list
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
